import { FormControls } from '@shared/Frontend/forms'
import { Clickable } from '@shared/Frontend/utils/clickable'
import { navigate } from '@shared/Frontend/utils/link'
import { SVGIcon } from '@shared/Frontend/utils/svg'
import { translate } from '@shared/Frontend/utils/translate'
import React, { useState } from 'react'

export const PageheaderSearchForm = () => {
  const [query, setQuery] = useState('')

  const submitSearch = () => {
    const searchUrl = translate('common:header:searchUrl', {}, '/en/search')
    const searchParams = query ? `?searchQuery=${encodeURIComponent(query)}` : ''
    navigate(`${searchUrl}${searchParams}`)
  }

  return (
    <form
      className='ph__search searchform'
      role='search'
      onSubmit={(e) => {
        e.preventDefault()
        submitSearch()
      }}
    >
      <FormControls.FormItemInGroup
        key='pageheader-input'
        type='text'
        inputMode='text'
        controlId='pageheader-input'
        label={translate('common:header:searchLabel', {}, 'What do you want to search for?')}
        placeholder={translate('common:header:searchPlaceholder', {}, 'Search for example by theme')}
        disabled={false}
        required={true}
        invalid={false}
        value={query}
        onChange={setQuery}
      />

      <Clickable
        elementKind="button"
        styleKind="button"
        label="Zoeken"
        className="button ph--desk-search"
        hasBlob={true}
        icon={'icon-chevron-right'}
        type='submit'
      />

      <button className='searchform__button ph--mob-search' type='submit'>
        <span className='sr-text'>Zoeken</span>
        <SVGIcon id='icon-search' size={24} className='searchform__icon' />
      </button>
    </form>
  )
}
